import { Megaphone } from "lucide-react";
import { Switch } from "../ui/switch";
import { Field, inputCls } from "./Field";

const TONES = [
  ["accent", "Main accent", "bg-accent text-onaccent"],
  ["accent2", "Second accent", "bg-accent2 text-white"],
  ["dark", "White", "bg-white text-black"],
];

const Preview = ({ a, lang }) => {
  const tone = (TONES.find(([k]) => k === a.color) || TONES[0])[2];
  const text = (lang === "ar" && a.text_ar) || a.text;
  const label = (lang === "ar" && a.link_label_ar) || a.link_label;
  return (
    <div dir={lang === "ar" ? "rtl" : "ltr"} className={`flex min-h-10 items-center justify-center gap-3 rounded-lg px-4 py-2 text-center text-sm font-semibold ${tone} ${lang === "ar" ? "font-arabic" : ""}`}>
      <Megaphone size={15} />
      <span>{text || (lang === "ar" ? "اكتب نص الإعلان" : "Type your announcement")}</span>
      {label && <span className="underline underline-offset-4">{label}</span>}
    </div>
  );
};

export const AnnouncementEditor = ({ value: a, onChange }) => {
  const set = (k, v) => onChange({ ...a, [k]: v });
  return (
    <div className="space-y-4 rounded-2xl border border-white/10 bg-[#12121A] p-5" data-testid="admin-announcement-editor">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h3 className="font-display text-lg font-bold text-white">Announcement bar</h3>
          <p className="text-sm text-zinc-400">A strip above the top menu, e.g. holiday closures or a new batch launch. Visitors can close it.</p>
        </div>
        <label className="flex shrink-0 items-center gap-3">
          <span className={`text-sm font-semibold ${a.enabled ? "text-[#CCFF00]" : "text-zinc-400"}`}>{a.enabled ? "On" : "Off"}</span>
          <Switch checked={a.enabled} onCheckedChange={(v) => set("enabled", v)} data-testid="admin-announcement-toggle" />
        </label>
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        <Field label="Message (English)"><input className={inputCls} value={a.text} placeholder="e.g. Studio closed 25–27 Feb for National Day" onChange={(e) => set("text", e.target.value)} data-testid="admin-announcement-text" /></Field>
        <Field label="Message (Arabic)"><input dir="rtl" className={`${inputCls} font-arabic`} value={a.text_ar} onChange={(e) => set("text_ar", e.target.value)} data-testid="admin-announcement-text-ar" /></Field>
        <Field label="Button text (optional, English)"><input className={inputCls} value={a.link_label} placeholder="e.g. Book now" onChange={(e) => set("link_label", e.target.value)} data-testid="admin-announcement-link-label" /></Field>
        <Field label="Button text (optional, Arabic)"><input dir="rtl" className={`${inputCls} font-arabic`} value={a.link_label_ar} onChange={(e) => set("link_label_ar", e.target.value)} data-testid="admin-announcement-link-label-ar" /></Field>
        <Field label="Button link (WhatsApp, Instagram post, any web link)" className="sm:col-span-2"><input className={inputCls} value={a.link_url} placeholder="https://" onChange={(e) => set("link_url", e.target.value)} data-testid="admin-announcement-link-url" /></Field>
      </div>
      <div>
        <span className="mb-2 block font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-400">Colour</span>
        <div className="flex flex-wrap gap-2">
          {TONES.map(([k, label, cls]) => (
            <button key={k} type="button" onClick={() => set("color", k)} data-testid={`admin-announcement-color-${k}`}
              className={`rounded-full px-4 py-2 text-sm font-semibold ${cls} ${a.color === k ? "ring-2 ring-white ring-offset-2 ring-offset-[#12121A]" : "opacity-70"}`}>{label}</button>
          ))}
        </div>
      </div>
      <div className="space-y-2 border-t border-white/[0.08] pt-4">
        <span className="block font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-400">Preview</span>
        <Preview a={a} lang="en" />
        <Preview a={a} lang="ar" />
      </div>
    </div>
  );
};
